import {CreateEventFormDialog} from '@/features/agenda/components/create-event-form-dialog/CreateEventFormDialog'
import {DialogStore} from '@ariakit/react'
import dayjs from 'dayjs'
import {useMemo} from 'react'

export const AgendaCreateEventContextMenuDialog = ({
    start,
    end,
    createEventDialogStore
}: {
    start: Date
    end: Date
    createEventDialogStore: DialogStore
}) => {
    const defaultValues = useMemo(() => {
        return {
            type: 'event' as const,
            category: 'treatments' as const,
            status: 'provisional' as const,
            isGroupTreatment: false,
            consultants: [{fullName: '', id: ''}],
            teamMembers: [],
            patients: [],
            date: {
                date: dayjs(start).toDate(),
                time: dayjs(start).format('HH:mm'),
                location: 'clinic' as const
            },
            duration: dayjs(end).diff(dayjs(start), 'minute').toString()
        }
    }, [])

    return <CreateEventFormDialog defaultValues={defaultValues} providedDialogStore={createEventDialogStore} />
}
